import {
  FaPaintBrush,
  FaPenNib,
  FaCamera,
  FaVideo,
  FaPalette,
  FaLaptopCode,
  FaImage,
  FaFigma,
} from "react-icons/fa";

import { FaFilm } from "react-icons/fa";

const skills = [
  {
    icon: <FaPaintBrush size={34} />,
    name: "Photoshop",
    color: "bg-blue-100",
    text: "text-blue-700",
  },
  {
    icon: <FaPenNib size={34} />,
    name: "Illustrator",
    color: "bg-orange-100",
    text: "text-orange-600",
  },
  {
    icon: <FaPalette size={34} />,
    name: "InDesign",
    color: "bg-pink-100",
    text: "text-pink-600",
  },
  {
    icon: <FaCamera size={34} />,
    name: "Lightroom",
    color: "bg-cyan-100",
    text: "text-cyan-600",
  },
  {
    icon: <FaLaptopCode size={34} />,
    name: "Adobe XD",
    color: "bg-purple-100",
    text: "text-purple-600",
  },
  {
    icon: <FaVideo size={34} />,
    name: "Premiere Pro",
    color: "bg-indigo-100",
    text: "text-indigo-600",
  },
  {
    icon: <FaImage size={34} />,
    name: "After Effects",
    color: "bg-violet-100",
    text: "text-violet-600",
  },
  {
    icon: <FaFigma size={34} />,
    name: "Figma",
    color: "bg-gray-100",
    text: "text-red-500",
  },
];

export default function Skills() {
  return (
    <section className="py-10">
      <div className="max-w-7xl mx-auto px-6">

        <div className="flex flex-wrap justify-center gap-8">

          {skills.map((skill) => (
            <div
              key={skill.name}
              className="group flex flex-col items-center"
            >
              <div
                className={`
                  ${skill.color}
                  ${skill.text}
                  w-20
                  h-20
                  rounded-2xl
                  shadow-lg
                  flex
                  items-center
                  justify-center
                  transition
                  duration-300
                  group-hover:-translate-y-3
                  group-hover:scale-110
                `}
              >
                {skill.icon}
              </div>

              <span className="mt-3 text-xs uppercase tracking-wider text-gray-500 opacity-0 group-hover:opacity-100 transition">
                {skill.name}
              </span>
            </div>
          ))}

        </div>

      </div>
    </section>
  );
}